import Vue from 'vue';
import Meta from 'vue-meta';
import Router from 'vue-router';
import routes from './routes';
import store from '@/store';
import chainGuards, { storeRouteQuery, authorize, newRelic } from './guards';

// NavigationDuplicated error is called everytime path/name doesn't change, even if params or query change.
// This prevents NavigationDuplicated errors clogging up console.log in IndexQuery
(() => {
  const orgReplace = Router.prototype.replace;
  Router.prototype.replace = function replace(location) {
    return orgReplace.call(this, location).catch(err => {
      if (err.name !== 'NavigationDuplicated') throw err;
    });
  };
})();

const scrollBehavior = function(to, from, savedPosition) {
  if (savedPosition) {
    // savedPosition is only available for navigation with browser buttons
    return savedPosition;
  } else {
    const position = {};

    // scroll to anchor by returning the selector
    if (to.hash) {
      position.selector = to.hash;

      // bypass #1number check
      if (/^#\d/.test(to.hash) || document.querySelector(to.hash)) {
        return position;
      }

      // if the returned position is falsy or an empty object,
      // will retain current scroll position.
      return false;
    }

    return new Promise(resolve => {
      // check if any matched route config has meta that requires scrolling to top
      if (to.matched.some(m => m.meta.scrollToTop)) {
        // coords will be used if no selector is provided,
        // or if the selector didn't match any element.
        position.x = 0;
        position.y = 0;
      }

      // wait for the out transition to complete (if necessary)
      this.app.$root.$once('triggerScroll', () => {
        // if the resolved position is falsy or an empty object,
        // will retain current scroll position.
        resolve(position);
      });
    });
  }
};

Vue.use(Router);
Vue.use(Meta);

const router = new Router({
  mode: 'history',
  fallback: false,
  base: process.env.BASE_URL,
  routes,
  scrollBehavior,
});

// Authorize and authenticate on startup
router.beforeEach(chainGuards(newRelic, authorize, storeRouteQuery));

// router.beforeResolve((to, from, next) => {
//   next();
// });

router.afterEach(() => {
  store.set('app/maxBreakpoint', undefined); // reset breakpoint to its default when navigating away
  // BUG: resets after routerReplace (query updates).
  // REFACTOR: use $route.meta.maxBreakpoint and beforeResolve
});

export default router;
